import { IRoute } from "../../../common/helpers/routesMapper";
import withRouter from "../../utils/withRouter";
import { connect } from "react-redux";
import injectIntl from "../../../common/helpers/injectIntl";

import { seo } from "../../../common/helpers/seo";

import { changeStudentColors, changeStudentSolfaAudio, changeStudentPitchNotation, changeStudentRhythmSyllableTypes, changeStudentReversedToneset, changeStudentSolfaShort, changeStudentSolfaKam } from "../../store/user/actions";
import taskCompleted from "../../store/plan/actions/taskCompleted";
import { get, post } from "../../actions/general";

import lazyComponent from "./lazy";
import { Store } from "redux";
import { IUser } from "../../store/user/models";
import { IStateTree } from "../../store/interfaces";

const mapDispatchToProps = {
    get,
    post,
    taskCompleted,
    changeStudentColors,
    changeStudentPitchNotation,
    changeStudentRhythmSyllableTypes,
    changeStudentReversedToneset,
    changeStudentSolfaShort,
    changeStudentSolfaAudio,
    changeStudentSolfaKam,
};

const mapStateToProps = ({ user }: IStateTree) => ({
    user: user as IUser
});

export default {
    component: withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(lazyComponent))),
    renderSeo: (store: Store, allMessage: { [key: string]: string }, lang: string) => {
        return seo({ title: allMessage["homework"], allMessage, lang });
    },
} satisfies IRoute;
